var map = {
	"./block-banner/block-banner.js": "../modules/block-banner/block-banner.js",
	"./block-gallery/block-gallery.js": "../modules/block-gallery/block-gallery.js",
	"./block-new-page/block-new-page.js": "../modules/block-new-page/block-new-page.js",
	"./block-other-product/block-other-product.js": "../modules/block-other-product/block-other-product.js",
	"./block-other/block-other.js": "../modules/block-other/block-other.js",
	"./block-product/block-product.js": "../modules/block-product/block-product.js",
	"./block-search/block-search.js": "../modules/block-search/block-search.js",
	"./product-detail/product-detail.js": "../modules/product-detail/product-detail.js",
	"./product-gallery/product-gallery.js": "../modules/product-gallery/product-gallery.js"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "../modules sync recursive ^\\.\\/.*\\/.*\\.js$";